module.exports = __webpack_public_path__ + "0f74c2f2472bc65dc0757c335e2dab93.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/un.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/un.svg
// module chunks = 0